import React, { useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import * as Dati from "src/Dati";
import * as DatiFide from "src/DatiFide";
import * as Glob from "src/Globale";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { Trad } from "src/components/";
import { _Button, _ButtonAPI, _CalculationSection, _EconomicData } from "../../components";
import { _Autocomplete, _DateField, _Select } from "../../form";
import { IRouteParam } from "../../pages/BondsAssessment";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

export const _BondsAssessmentForm: React.FC = () => {
    const history = useHistory();
    const { ID_Anag, ID_FideAffidamento, ID_FideValutazione } = useParams<IRouteParam>();
    const { ShowDialog } = useContext(AlertDialogContext);

    const editingRights = Glob.AzioneAbilitata("FideValutazioneController", Glob.Scrittura);
    const initialData = new DatiFide.CRisAPIDatoTipi_FideValutazione();
    initialData.Dato.ID_FideAffidamento = Number(ID_FideAffidamento);

    const [Data, setData] = useReducerOnChange<DatiFide.CRisAPIDatoTipi_FideValutazione>(initialData);

    useEffect(() => {
        GetData();
    }, [ID_Anag, ID_FideAffidamento, ID_FideValutazione]);

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/fidevalutazione/seleziona?ID_FideValutazione=${ID_FideValutazione}&ID_Anag=${ID_Anag}&ID_FideAffidamento=${ID_FideAffidamento}`,
            OnRis: OnGetData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, data: DatiFide.CRisAPIDatoTipi_FideValutazione) => {
        setData({ Type: "Set", Value: data });
    };

    const GetFormData = (): Dati.CIngrAPITipi<DatiFide.CDatiFideValutazione> => {
        const formData = new Dati.CIngrAPITipi<DatiFide.CDatiFideValutazione>();
        formData.Dato = Data.Dato;

        return formData;
    };

    const OnClickSave = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            if (ID_FideValutazione == "0") {
                history.push(`/anagrafica/${ID_Anag}/fideaffidamento/${ID_FideAffidamento}/FideValutazione/${data.ID_Chiave}`);
            }
            ShowDialog("VALUTAZIONE", Trad.TradParam("Valutazione salvata correttamente con ID: {1-S}", [data.ID_Chiave]), "success");
        }
    };

    const isFormValid = Data?.Dato?.Note?.length > 15;

    return (
        <Card>
            <CardContent>
                <form noValidate autoComplete="off">
                    <Grid container spacing={5}>
                        <Grid item container spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    disabled
                                    id="Dato.ID_FideAffidamento"
                                    label={Trad.Trad("ID")}
                                    value={Data.Dato.ID_FideAffidamento}
                                    onChange={e => setData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Disabled
                                    SearchInput
                                    Value={Data.Dato.ID_FideAffidamento}
                                    Name="Dato.ID_FideAffidamento"
                                    Label="Affidamento"
                                    OnChange={(e, val) => setData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url={`/api/FideAffidamento/ListaAffidamentiAnagrafica?sottoscritti=false&ID_AnagA=${ID_Anag}`}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_DateField Value={Data.Dato.Data} Name="Dato.Data" Label="Data valutazione" OnChange={(e, val) => setData({ Type: "OnChangeFromValue", Name: e, Value: val })} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_Select
                                    Value={Data.Dato.ID_TipoValutazioneEsito || Glob.Tipi_VA_InValutazione}
                                    Name="Dato.ID_TipoValutazioneEsito"
                                    Label="TipoValutazioneEsito"
                                    OnChange={(e, val) => setData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Options={(Data?.Tipi && Data.Tipi["TipiFideValutazioneEsito"]) || {}}
                                />
                            </Grid>
                        </Grid>
                        <Grid item>
                            <_CalculationSection Data={Data.Dato} OnChange={(e, val) => setData({ Type: "OnChangeFromValue", Name: e, Value: val })} />
                        </Grid>
                        {Data.Dato.ID_DatoEconomico > 0 && (
                            <Grid item xs={12}>
                                <_EconomicData Data={Data.Dato} OnApiError={OnApiError} OnChange={e => setData({ Type: "OnChangeFromForm", Target: e.currentTarget })} />
                            </Grid>
                        )}
                    </Grid>
                </form>
            </CardContent>
            {editingRights && (
                <CardActions disableSpacing>
                    <Grid item container xs={12} spacing={3} justify="flex-end">
                        <Grid item>
                            <_ButtonAPI Default Attivo={isFormValid} Testo={Trad.Trad("Salva")} URL="/api/fidevalutazione/" OnInvio={GetFormData} OnClick={OnClickSave} OnErrore={OnApiError} />
                        </Grid>
                        <Grid item>
                            <_Button Default={false} WithWrapper={false} Testo={Trad.Trad("Annulla")} OnClick={GetData} />
                        </Grid>
                    </Grid>
                </CardActions>
            )}
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsAssessment/BondsAssessmentForm.tsx